import { useEffect, useState, useRef } from 'react'
import Tabs from '../../../Components/Tabs'
import GetIcon from '../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import { usePostItemListMutation } from '../../../store/api/picklist'
import Button from '../../../Core/Button/Button'
import printerimg from "../../../assets/print.png"
import { usePostMappedPicklistMutation, usePostCreatePicklistMutation, useGetPicklistDetailsQuery, useLazyGetPicklistDetailsQuery, usePostUpdatePickListMutation, usePostSubmitPickListMutation } from '../../../store/api/picklist'
import { useCreateDeliveryNotePicklistMutation } from '../../../store/api/deliveryNoteApi'
import ApiResponseBox from '../../../Components/ApiResponseBox'
import PrintModal from "../../../../src/Core/Print/PrintModal";
import Attachment from '../../../utils/Attachment'


function Pick({ pick_id }) {
    const [buttonData, setButtonData] = useState(false)
    const nvg = useNavigate()
    const scanItemRef = useRef(null);
    const [tab, settab] = useState(1)
    const [result, setResult] = useState(false)
    const [tabdata, setTabdata] = useState({})
    const [selected_item_data, setselected_item_data] = useState([]);
    const [getitem_list_data] = usePostItemListMutation()
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [itemList, setItemList] = useState([]);
    console.log(itemList, "itemList");
    const [fulldata, setfulldata] = useState();
    const [item_Rows, setitem_Rows] = useState([]);
    const [postMappedPicklist] = usePostMappedPicklistMutation();
    const [scannedBin, setScannedBin] = useState('');
    const [scannedItem, setScannedItem] = useState('');
    const [scanboll, setscanboll] = useState(false);
    const [picklist_id, setpicklist_id] = useState();
    const [submit, setsubmit] = useState(false);
    const [update, setupdate] = useState(false);
    const [selectRow, setselectRow] = useState("");
    const [activityboll, setactivityboll] = useState(false)
    const [showPrintModal, setShowPrintModal] = useState(false);




    const [originalItems, setOriginalItems] = useState([]);



    const [trigger, { data, error2, isFetching2 }] = useLazyGetPicklistDetailsQuery();

    useEffect(() => {
        if (!pick_id) return;

        const fetchPickListDetails = async () => {
            try {
                const result = await trigger({ doctype: 'Pick List', name: pick_id }).unwrap();
                setfulldata(result);

                const updatedRows = result.message.locations.map(item => ({
                    ...item,
                    picked_qty: 0,
                }));

                setItemList(updatedRows);
                setOriginalItems(updatedRows);
                setitem_Rows(updatedRows);
            } catch (error) {
                console.error('Failed to fetch pick list details:', error);
            }
        };

        fetchPickListDetails();
    }, [pick_id]);


    const pickListdetail = async (pick_id) => {
        console.log(picklist_id, "picklist_id");
        const result = await trigger({ doctype: 'Pick List', name: pick_id }).unwrap();
        setfulldata(result)
        let updatedRows = result.message.locations.map(item => ({
            ...item,
            picked_qty: 0,
        }));
        setItemList(updatedRows);
        setOriginalItems(updatedRows);
        setitem_Rows(updatedRows);



    }

    const handleBinScan = (e) => {
        scanItemRef.current?.focus();
        e.preventDefault();
        if (scannedBin.trim()) {
            const filtered = originalItems.filter(item => item.warehouse === scannedBin.trim());
            setitem_Rows(filtered);
        } else {
            handleClearBinFilter();
        }
    };
    const handleClearBinFilter = () => {
        setScannedBin('');
        setitem_Rows(originalItems);
    };

    const handleItemScan = (e) => {
        e.preventDefault();
        setScannedItem("");

        if (scannedItem.trim()) {
            let flag = false;
            let matchedItem = null;

            try {
                const filtered = item_Rows.map((item) => {
                    if (!(item.warehouse == scannedBin.trim())) {
                        throw "Item needs to be in the same Warehouse";
                    }

                    if (item.item_code === scannedItem.trim()) {
                        const currentPickedQty = parseInt(item.picked_qty || 0);
                        const totalQty = parseInt(item.qty || 0);

                        if (currentPickedQty >= totalQty) {
                            throw "Picked quantity exceeds available quantity";
                        }

                        item.picked_qty = currentPickedQty + 1;
                        flag = true;
                        matchedItem = { ...item };
                    }

                    return item;
                });

                if (flag && matchedItem) {
                    const updatedList = [
                        matchedItem,
                        ...filtered.filter((item) => item.item_code !== matchedItem.item_code),
                    ];

                    setitem_Rows(updatedList);
                    setselectRow(matchedItem);
                } else {
                    alert("Product Not Found");
                }
            } catch (err) {
                alert(err);
                console.log(err);
            }
        }
    };
    const totalPickedQty = item_Rows.reduce((total, item) => {
        return total + (Number(item.picked_qty) || 0);
    }, 0);


    const totalQty = item_Rows.reduce((total, item) => {
        return total + (item.order_qty || 0);
    }, 0);
    const totalaccepted = item_Rows.reduce((total, item) => {
        return total + (item.qty || 0);
    }, 0);

    const [postCreatePicklist, { isLoading, isSuccess, isError }] = usePostCreatePicklistMutation();





    const [postupdatePicklist, { isLoadingtwo, isSuccesstwo, isErrortwo }] = usePostUpdatePickListMutation();


    const handleClicksave = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: pick_id,
            locations: item_Rows.map(item => ({
                name: item.name,
                item_code: item.item_code,
                warehouse: item.warehouse,
                picked_qty: item.picked_qty,
                qty: item.qty,
            })),
        };
        console.log(payload, "payload");


        postupdatePicklist(payload)
            .unwrap()
            .then(res => {
                console.log('Picklist updated:', res);
                setupdate(true)
                setError('Updated');
                setptype('Picklist updated');
                setShowError(true);
                setactivityboll(prev => !prev);
                // setpicklist_id(res.result.pick_list)
                // setscanboll(true)
                // pickListdetail(res.result.pick_list)
            })
            .catch(err => {
                alert('Error creating picklist:', err)
                console.error('Error creating picklist:', err);
            });
    };



    const [postsubmitPicklist, { isLoadithree, isSuccessthree, isErrorthree }] = usePostSubmitPickListMutation();


    const handleClicksubmit = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: picklist_id,

        };
        console.log(payload, "payload");


        postsubmitPicklist(payload)
            .unwrap()
            .then(res => {
                console.log('Picklist submited:', res);
                setsubmit(true)
                setError('Submited');
                setptype('Picklist submited');
                setShowError(true);
                setactivityboll(prev => !prev);

            })
            .catch(err => {
                console.error('Error creating picklist:', err);
            });
    };


    const [createDeliveryNote, { isLoadingfive, errortwo }] = useCreateDeliveryNotePicklistMutation();

    const handleDevlivaryPick = async () => {
        try {
            const response = await createDeliveryNote(picklist_id).unwrap();

            const delivery_note_id = response.result.delivery_note_id
            console.log('Delivery Note created:', delivery_note_id);
            nvg('/outbound/outbound-create-delivery-note', {
                state: { delivery_note_id: delivery_note_id }
            });
        } catch (error) {
            console.error('Failed to create pick:', error);
            alert('Error creating pick. Please try again.');
        }
    };


    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px', }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Warehouse</p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/assmbly/pick-list')}>Pick List </p>
                    <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        View Pick
                        <button
                            className={`rounded-pill ${fulldata?.message?.status === "Completed" ? 'newdesign123' : 'newdesign2343'
                                }`}
                        >
                            {fulldata?.message?.status}
                        </button>

                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                     <p className="p-0 m-0">
                        <img src={printerimg} 
                        onClick={() => setShowPrintModal(true)} 
                         className="px-2" style={{width:'35px',cursor:'pointer'}} alt="404" />
                    </p>
                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff",flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                           <Attachment doctype="Pick List"  docname={pick_id}  /> 

                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 fulldata={fulldata} order_id={pick_id} activityboll={activityboll} picklist_id={picklist_id} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            {/* Left Side Text Info */}
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <p className="NoOfLine">
                                    No. of lines - <span style={{ color: '#2563EB' }}>{item_Rows.length}</span>
                                </p>
                                <p className="TotalQty">
                                    Total Quantity - <span style={{ color: '#16A34A' }}>{totalaccepted > 0 ? totalaccepted : totalQty}</span>
                                </p>
                                {/* <p className="ReceivedQty">
                                    Scanned Quantity - <span style={{ color: '#EC642A' }}>{totalPickedQty}</span>
                                </p> */}
                            </div>
                            {scanboll &&
                                <div className="d-flex mx-2" style={{ gap: '10px', borderColor: 'rgba(0,0,0,0.2)' }}>
                                    <form onSubmit={handleBinScan}>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                name="binScan"
                                                placeholder="Scan Bin"
                                                className="form-control pe-4"
                                                value={scannedBin}
                                                onChange={(e) => setScannedBin(e.target.value)}
                                                style={{
                                                    width: '227px',
                                                    border: '1px solid #333',
                                                }}
                                            />
                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    color: "#EC642A"
                                                }}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>
                                    </form>



                                    <form onSubmit={handleItemScan}>
                                        <div className="position-relative" style={{ width: '227px' }}>
                                            <div
                                                style={{ position: 'relative' }}
                                                title={!scannedBin ? 'Scan Bin' : ''}
                                            >
                                                <input
                                                    ref={scanItemRef}
                                                    type="text"
                                                    placeholder="Scan Item"
                                                    className="form-control pe-4"
                                                    value={scannedItem}
                                                    onChange={(e) => setScannedItem(e.target.value)}
                                                    disabled={!scannedBin}
                                                    style={{
                                                        width: '100%',
                                                        border: '1px solid #333',
                                                        backgroundColor: !scannedBin ? '#f1f1f1' : 'white',
                                                        cursor: !scannedBin ? 'not-allowed' : 'text',
                                                    }}
                                                />

                                                {!scannedBin && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            right: '40px',
                                                            transform: 'translateY(-50%)',
                                                            pointerEvents: 'none',
                                                            color: '#999',
                                                        }}
                                                    >
                                                        <GetIcon iconName="MdBlock" size={16} />
                                                    </div>
                                                )}
                                            </div>

                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                disabled={!scannedBin}
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: !scannedBin ? 'not-allowed' : 'pointer',
                                                    color: "#EC642A",
                                                }}
                                                title={!scannedBin ? 'Scan Bin' : 'Submit'}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>

                                    </form>
                                </div>}

                        </div>
         <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table list_data={itemList} fulldata={fulldata} row={{ Rows: item_Rows, setRows: setitem_Rows, selectRow }} scanboll={scanboll} submit={submit} />
                    </div>
                </div>
                                                      {showPrintModal && (
                <PrintModal 
                    onClose={() => setShowPrintModal(false)}
                    documentId={pick_id}
                     doctype="Pick List"
                    title="Print GRN"
                />
            )}
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </div>
        </>
    )
}

export default Pick